var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEspaceSuiviIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "#FAF8F6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 30,
    height: 30,
    fill: "white",
    stroke: "#E6E6E7",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.000 10.821) scale(0.6071)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 8.98926,
    width: 6.18102,
    height: 2,
    rx: 1,
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.28516,
    y: 1.75195,
    width: 1.95866,
    height: 9.33141,
    rx: 0.979329,
    transform: "rotate(19.1122 7.28516 1.75195)",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.88281,
    y: 1.65234,
    width: 2.24429,
    height: 20.2288,
    rx: 1.12214,
    transform: "rotate(-8.09595 6.88281 1.65234)",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.6016,
    y: 9,
    width: 2.32075,
    height: 12.6665,
    rx: 1.16038,
    transform: "rotate(14.7315 12.6016 9)",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.3633,
    y: 9.25293,
    width: 11.1258,
    height: 2,
    rx: 1,
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.5703,
    width: 2.40245,
    height: 11.6848,
    rx: 1.20123,
    transform: "rotate(24.2697 25.5703 0)",
    fill: "#0A0A0B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEspaceSuiviIcon);
export default __webpack_public_path__ + "static/media/espaceSuiviIcon.c7298f3d741428b1adc10006051596e6.svg";
export { ForwardRef as ReactComponent };